import React, { useState } from 'react';
import Layout, { Container } from "../components/layout";

const StockIn = () => {
  const [form, setForm] = useState({
    type: "Stock In",
    quantity: "",
    receivedBy: "",
    receivedFrom: "",
    remark: "",
    date: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Stock In Submitted:", form);
    // Further logic here
  };

  return (
    <Layout>
      <div className="flex items-center justify-center min-h-screen bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
        <Container className="w-full max-w-lg">
          <div className="bg-white p-8 shadow-lg rounded-lg">
            <h2 className="text-2xl font-semibold text-gray-700 mb-6 text-center">Stock In Form</h2>
            <form className="space-y-4" onSubmit={handleSubmit}>
              {/* Type (static) */}
              <div>
                <label className="block text-sm font-medium text-gray-600">Type</label>
                <input
                  type="text"
                  name="type"
                  value={form.type}
                  readOnly
                  className="mt-1 w-full bg-gray-100 border border-gray-300 rounded-md p-2 text-gray-600"
                />
              </div>
              {/* Quantity */}
              <div>
                <label className="block text-sm font-medium text-gray-600">Quantity</label>
                <input
                  type="number"
                  name="quantity"
                  value={form.quantity}
                  onChange={handleChange}
                  required
                  className="mt-1 w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>
              {/* Received By */}
              <div>
                <label className="block text-sm font-medium text-gray-600">Received By</label>
                <select
                  name="receivedBy"
                  value={form.receivedBy}
                  onChange={handleChange}
                  required
                  className="mt-1 w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500"
                >
                  <option value="">-- Select --</option>
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="C">C</option>
                </select>
              </div>
              {/* Received From */}
              <div>
                <label className="block text-sm font-medium text-gray-600">Received From</label>
                <select
                  name="receivedFrom"
                  value={form.receivedFrom}
                  onChange={handleChange}
                  required
                  className="mt-1 w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500"
                >
                  <option value="">-- Select --</option>
                  <option value="Vendor A">Vendor A</option>
                  <option value="Vendor B">Vendor B</option>
                  <option value="Warehouse X">Warehouse X</option>
                </select>
              </div>
              {/* Remark */}
              <div>
                <label className="block text-sm font-medium text-gray-600">Remark</label>
                <textarea
                  name="remark"
                  value={form.remark}
                  onChange={handleChange}
                  className="mt-1 w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500"
                  rows={3}
                />
              </div>
              {/* Date */}
              <div>
                <label className="block text-sm font-medium text-gray-600">Date</label>
                <input
                  type="date"
                  name="date"
                  value={form.date}
                  onChange={handleChange}
                  required
                  className="mt-1 w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>
              {/* Submit Button */}
              <div>
                <button
                  type="submit"
                  className="w-full py-2 px-4 bg-indigo-600 text-white font-semibold rounded-md hover:bg-indigo-700 transition"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </Container>
      </div>
    </Layout>
  );
};

export default StockIn;
